import {
  ProjectLinks,
  ProjectLink,
  EmailLink,
} from "../components/ProjectLinks.jsx";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

export default function Bio() {
  return (
    <Stack sx={styles.container}>
      <img
        alt="headshot"
        className="project-img"
        src={require("../pictures/profile.JPG")}
        width={200}
      />

      <Typography align="justify" sx={styles.text}>
        Hello, I'm <b>Brian Tai</b>. I graduated from <b>Hamilton College</b>{" "}
        with Computer Science and Math degrees. I am a professional software
        engineer based in San Francisco, specializing in full-stack development.
        <br />
        <br />
        Outside of work, I enjoy rock climbing, skateboarding, swimming, biking,
        and learning guitar. I also run a machine learning paper reading group
        called the 90/30 Club.
      </Typography>

      <ProjectLinks>
        <ProjectLink link="https://github.com/brianiscoding" icon="github">
          Github
        </ProjectLink>
        <ProjectLink
          icon="linkedin"
          link="https://www.linkedin.com/in/taibrian/"
        >
          LinkedIn
        </ProjectLink>
        <ProjectLink icon="work" link="https://www.trekhealth.io">
          TrekHealth.io
        </ProjectLink>
        <EmailLink email="taibriansf@gmail.com">taibriansf@gmail.com</EmailLink>
        <ProjectLink link="https://luma.com/9030club">90/30 Club</ProjectLink>
      </ProjectLinks>
    </Stack>
  );
}

const styles = {
  container: {
    width: 1,
    height: 1,
    alignItems: "center",
    justifyContent: "space-evenly",
  },

  text: {
    width: 0.9,
    fontSize: 20,
  },
};
